<template lang="pug">
app-error(v-if="error", tag="property")
app-loader(v-else-if="!loaded && !error", key="loader")
#next_gen(v-else)
  .app-page(:aria-label="`${data.Title} listing page`")
    app-filters(:terms="data.TermsFilter", :data="term.Filters")
    app-grid(:data="term.Attributes", :footer="data.FooterText")
    app-related(v-if="data.SisterProperty", :data="data.SisterProperty")
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import ManageApply from "@/listing-app/mixins/ManageApply";
import ManageHeaderApply from "@/listing-app/mixins/ManageHeaderApply";

import Filters from "@/listing-app/components/listing/Filters";
import Grid from "@/listing-app/components/listing/Grid";
import Related from "@/listing-app/components/listing/Related";
import Loader from "@/listing-app/components/Loader";
import Error from "@/listing-app/components/Error";

export default {
  name: "Listing",
  mixins: [ManageApply, ManageHeaderApply],
  components: {
    appFilters: Filters,
    appGrid: Grid,
    appRelated: Related,
    appLoader: Loader,
    appError: Error,
  },
  data() {
    return {
      banner_markup: undefined,
      endpoint: document.querySelector("#endpointURL").value,
      headerText: document.querySelector("#headerText").value,
    };
  },
  computed: {
    ...mapGetters(["read"]),
    loaded() {
      return this.read("loaded");
    },
    error() {
      return this.read("error");
    },
    term() {
      return this.read("term");
    },
    data() {
      return this.read("property");
    },
  },
  methods: {
    ...mapActions(["set"]),
    init() {
      this.set({ muta: "error", data: false });
   
      // check if the property already exists in the store
      if (
        !Object.keys(this.read("property")).length &&
        !Object.keys(this.read("term")).length &&
        !Object.keys(this.read("filters")).length
      ) {
        this.set({ muta: "loaded", data: false });
        this.load_data();
      } else {
        if (this.$route.query.hasOwnProperty("detailError")) {
          this.$router.replace({ query: {} });
          this.load_data();
        }
        console.timeEnd("load_listing");
      }

      document.getElementById("header-apply")?.removeAttribute("hidden");
    },
    load_data() {
      this.$api
        .get(this.endpoint)
        .then((rsp) => {
          if (rsp) {
            let filteredRsp = this.filterTermData(rsp)
            this.set({ muta: "property", data: filteredRsp });
            this.set({ muta: "term", data: filteredRsp.Terms[0] });
            this.set({ muta: "theme", data: filteredRsp.Theme });
            this.set({ muta: "loaded", data: true });
            this.load_filters();
            this.set_header_apply_term(filteredRsp.Terms[0].ID);
          } else {
            this.set({ muta: "error", data: true });
          }
        })
        .catch((err) => {
          console.error(
            "The following error occured while trying to load site data:"
          );
          console.error(err);
          this.set({ muta: "error", data: true });
        })
        .finally(() => {
          console.timeEnd("load_listing");
        });
    },
    filterTermData(rsp) {
      //Move the default term to the top of the Terms array
      let termIndex = -1;

      for(let i = 0; i < rsp.TermsFilter.Values.length; i++) {
          if(rsp.TermsFilter.Values[i].Default === true) {
              let defaultTermId = rsp.TermsFilter.Values[i].ID;

              for(let i = 0; i < rsp.Terms.length; i++) {
                  if(rsp.Terms[i].ID === defaultTermId) {
                      termIndex = i;
                      break;
                  }
              }

              if(termIndex > -1) {
                  let term = rsp.Terms.splice(termIndex, 1)[0]; // Remove the term and get it
                  rsp.Terms.unshift(term); // Add the term to the top of the array
              }
          }
        }

        //Remove floorplans without an image
        rsp.Terms.forEach(function(term) { 
          const filteredAttributes = term.Attributes.filter(attribute => {
          return attribute.ImageURL !== null && attribute.ImageURL.trim() !== '' && attribute.ImageURL !== '/';
        });

        term.Attributes = filteredAttributes;
      });
      return rsp;
    },
    load_filters() {
      const terms = this.data.Terms;
      const query = this.$route.query;
      let filters = this.read("term").Filters;
      let value;
      let text;

      if (Object.keys(query).length) {
        filters.forEach((filter) => {
          if (filter.Type == "select") {
            // query check
            if (query.hasOwnProperty(filter.ID)) {
              let temp = filter.Values.filter((item) => {
                if (
                  item.ID == query[filter.ID] ||
                  item.Text == query[filter.ID]
                ) {
                  return true;
                }
                return false;
              });
              // if a match was found set filter
              if (temp.length) {
                value = temp[0].ID;
                text = temp[0].Text;
                this.set({
                  muta: "filters",
                  data: { filter: filter.ID, value, text },
                });
              }
            }
          } else if (filter.type == "multiselect") {
            // query check
            if (query.hasOwnProperty(filter.ID)) {
              let temp = filter.Values.filter((item) => {
                if (
                  item.ID == query[filter.ID] ||
                  item.Text == query[filter.ID]
                ) {
                  return true;
                }
                return false;
              });
              // if a match was found set filter
              if (temp.length) {
                let multi = [];
                temp.forEach((t) => multi.push({ value: t.ID, text: t.Text }));
                this.set({
                  muta: "filters",
                  data: { filter: filter.ID, multi },
                });
              }
            }
          } else if (filter.Type == "range") {
            // query check
            if (query.hasOwnProperty(filter.ID)) {
              value = query[filter.ID];
              this.set({ muta: "filters", data: { filter: filter.ID, value } });
            }
          }
        });
      }
    },
  },
  created() {
    console.time("load_listing");
    this.init();
    this.show_apply();
  }
};
</script>